<template>
  <div class="Approve" v-loading="loading">
    <rt-plat-header title="审批">
      <rt-toolbar show-autoback></rt-toolbar>
    </rt-plat-header>
    <rt-content id="approvemain">
      <div class="appcontent">
        <div id="left" :class="isMyApproval ? '' : 'leftAll'">
          <el-tabs type="border-card" :class="approveShowBtn ? 'approve_card_btn' : 'approve_card'" v-model="activeName"
            :tab-position="tabPosition" @tab-click="handleClick">
            <el-tab-pane name="page" v-if="decisiondisplayes">
              <span slot="label">{{
                $_t("单据详情", "approval.formdetail")
              }}</span>
              <component :is="formCom"></component>
            </el-tab-pane>
            <el-tab-pane :label="$_t('审批信息', 'approval.approvalinfo')" name="approve">
              <div class="rt-flow-left">
                <rt-flow-approval-list ref="_RTFlowApprovalList" :entityname="entityName" :id="entityId">
                </rt-flow-approval-list>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div id="right" v-if="isMyApproval">
          <div class="rt-crm-ApproveHeader">
            <div class="rt-crm-ApproveTitle">
              <!-- 签核处理 -->
              <span v-if="iscommunicate == 0">{{
                $_t("签核处理", "approval.signprocess")
              }}</span>
              <!-- 签核沟通 -->
              <span v-else>签核沟通</span>
            </div>
          </div>
          <!-- 签核处理 -->
          <div class="rt-crm-ApproveContent" v-if="iscommunicate == 0">
            <ul class="rt-crm-ApproveTabList">
              <li class="rt-crm-ApproveTab" :class="{ selected: actionType == 1 }" @click="actionType = 1">
                <!-- <span>同意</span> -->
                <span>{{ $_t("同意", "approval.agree") }}</span>
              </li>
              <li class="rt-crm-ApproveTab" :class="{ selected: actionType == 2 }" @click="actionType = 2">
                <!-- <span>驳回</span> -->
                <span>{{ $_t("驳回", "approval.reject") }}</span>
              </li>
              <li class="rt-crm-ApproveTab" v-show="allowCommunicate" :class="{ selected: actionType == 3 }"
                @click="actionType = 3">
                <!-- 沟通 -->
                <span>{{ $_t("沟通", "approval.communicate") }}</span>
              </li>
              <li class="rt-crm-ApproveTab" :class="{ selected: actionType == 4 }" @click="actionType = 4">
                <!-- 转办 -->
                <span>{{ $_t("转办", "approval.transfer") }}</span>
              </li>
            </ul>
            <!-- 同意 -->
            <div v-if="actionType == 1" class="rt-crm-ApproveTabContent">
              <div>
                <div class="rt-crm-ApproveSection">
                  <!-- 签核意见 -->
                  <div class="rt-crm-ApproveSectionTitle">
                    {{ $_t("签核意见", "approval.endorsingopinions")
                    }}<span v-if="ApproveMemoRequired">({{ $_t("必填", "common.isrequired") }})</span>
                  </div>
                  <!-- 请填写签核意见 -->
                  <textarea class="rt-crm-ApproveMemo" v-model="agreeInfo.memo" :placeholder="$_t('请填写', 'common.fillOut') +
                    $_t('签核意见', 'approval.endorsingopinions')
                    "></textarea>
                  <!-- <common-reviews class="commonleft" :action-type="actionType" :commonreviews-selected="handleCommonReviewsSelected"></common-reviews> -->
                  <!-- <CommonReviewsCollection class="commonright" :action-type="actionType" :content="agreeInfo.memo"></CommonReviewsCollection> -->
                </div>
                <div class="rt-crm-ApproveSection" style="margin-top: 36px;">
                  <!-- 加签用户 -->
                  <div class="rt-crm-ApproveSectionTitle">
                    {{ $_t("加签用户", "approval.signeduser") }}
                  </div>
                  <div class="userSelect">
                    <rt-radio-group v-model="radio">
                      <rt-radio-button :label="0" border>互联用户</rt-radio-button>
                      <rt-radio-button :label="1" border>系统用户</rt-radio-button>
                    </rt-radio-group>
                  </div>
                  <div class="rt-crm-AddedUser" v-for="user in addUsers" :key="user.systemuserid">
                    <div class="rt-crm-Avatar">{{ user.fullname }}</div>
                    <div class="rt-crm-DeleteMask" @click="deleteAddUser(user, 1)">
                      <i></i>
                    </div>
                    <p class="rt-crm-UserName">{{ user.fullname }}</p>
                  </div>
                  <div class="rt-crm-AddUser" @click="chooseAddUser()">
                    <div class="rt-crm-Avatar">+</div>
                    <div class="rt-crm-UserName">
                      {{ $_t("新增", "common.add") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 驳回 -->
            <div v-if="actionType == 2" class="rt-crm-ApproveTabContent">
              <div class="rt-crm-ApproveSection">
                <!-- 驳回到 -->
                <div class="rt-crm-ApproveSectionTitle">
                  {{ $_t("驳回到", "approval.refute") }}
                </div>
                <select v-model="rejectInfo.rejectToStepId">
                  <option value="">{{
                    $_t("申请人", "new_flowapprovalcrf.new_applyuser")
                  }}</option>
                  <option v-for="step in approvedStepList" :value="step.new_stepid" :key="step.new_stepid">{{
                    step.new_stepidName }}</option>
                </select>
              </div>
              <div class="rt-crm-ApproveSection" v-show="enableRejectType && !isDynamicFlow">
                <!-- 驳回选项 -->
                <div class="rt-crm-ApproveSectionTitle">
                  {{ $_t("驳回选项", "approval.rejectedoption") }}
                </div>
                <select v-model="rejectInfo.resubmitTypeId">
                  <!-- 驳回后流经的子流程重新流转 -->
                  <option value="0">{{
                    $_t(
                      "驳回后流经的子流程重新流转",
                      "approval.afterrefusedrestart"
                    )
                  }}</option>
                  <!-- 驳回的节点通过后直接返回本节点 -->
                  <option value="1">{{
                    $_t(
                      "驳回的节点通过后直接返回本节点",
                      "approval.afterrefusedcontinue"
                    )
                  }}</option>
                </select>
              </div>
              <div class="rt-crm-ApproveSection">
                <!-- 签核意见(必填) -->
                <div class="rt-crm-ApproveSectionTitle">
                  {{ $_t("签核意见", "approval.endorsingopinions")
                  }}<span v-if="ApproveMemoRequired">({{ $_t("必填", "common.isrequired") }})</span>
                </div>
                <!-- 请填写签核意见 -->
                <textarea :placeholder="$_t('签核意见', 'approval.endorsingopinions') +
                  '' +
                  $_t('必填', 'common.isrequired')
                  " v-model="rejectInfo.memo" class="rt-crm-ApproveMemo"></textarea>
                <!-- <common-reviews class="commonleft" :action-type="actionType" :commonreviews-selected="handleCommonReviewsSelected"></common-reviews> -->
                <!-- <CommonReviewsCollection class="commonright" :action-type="actionType" :content="rejectInfo.memo"></CommonReviewsCollection> -->
              </div>
            </div>

            <!-- 沟通   算了 太难了-->
            <div v-if="actionType == 3" class="rt-crm-ApproveTabContent">
              <div class="rt-crm-ApproveSection">
                <!-- 沟通用户 -->
                <div class="rt-crm-ApproveSectionTitle">
                  {{ $_t("沟通用户", "approval.communicateusers") }}
                </div>
                <div class="userSelect">
                  <rt-radio-group v-model="radio">
                    <rt-radio-button :label="0" border>互联用户</rt-radio-button>
                    <rt-radio-button :label="1" border>系统用户</rt-radio-button>
                  </rt-radio-group>
                </div>
                <div class="rt-crm-AddedUserList">
                  <div class="rt-crm-AddedUser" v-for="user in communicateInfo.userList" :key="user.systemuserid">
                    <div class="rt-crm-Avatar">{{ user.fullname }}</div>
                    <div class="rt-crm-DeleteMask" @click="deleteCommunicateUser(user)">
                      <i></i>
                    </div>
                    <p class="rt-crm-UserName">{{ user.fullname }}</p>
                  </div>
                  <div class="rt-crm-AddUser" @click="chooseAddUser()">
                    <div class="rt-crm-Avatar">+</div>
                    <div class="rt-crm-UserName">
                      {{ $_t("新增", "common.add") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="rt-crm-ApproveSection">
                <h4 v-cloak class="rt-crm-ApproveSectionTitle">
                  {{ $_t("备注", "SER_Notes")
                  }}<span v-if="ApproveMemoRequired">({{ $_t("必填", "common.isrequired") }})</span>
                </h4>
                <textarea :placeholder="$_t('请填写备注', 'PLEASE_FILL_IN_THE_NOTES')" class="rt-crm-ApproveMemo"
                  v-model="communicateInfo.memo"></textarea>
                <!-- <common-reviews class="commonleft" :action-type="actionType" :commonreviews-selected="handleCommonReviewsSelected"></common-reviews> -->
                <!-- <CommonReviewsCollection class="commonright" :action-type="actionType" :content="communicateInfo.memo"></CommonReviewsCollection> -->
              </div>
            </div>
            <!-- 转办 -->
            <div v-if="actionType == 4" class="rt-crm-ApproveTabContent">
              <div class="rt-crm-ApproveSection">
                <div class="rt-crm-ApproveSectionTitle">
                  {{ $_t("转办给", "approval.transferusers") }}
                </div>
                <div class="userSelect">
                  <rt-radio-group v-model="radio">
                    <rt-radio-button :label="0" border>互联用户</rt-radio-button>
                    <rt-radio-button :label="1" border>系统用户</rt-radio-button>
                  </rt-radio-group>
                </div>
                <div class="rt-crm-AddedUserList">
                  <div class="rt-crm-AddedUser" v-for="(user, index) in transferInfo.userList" :key="user.systemuserid">
                    <div v-cloak class="rt-crm-Avatar">
                      {{ user.fullname | surname }}
                    </div>
                    <div class="rt-crm-DeleteMask" @click="deleteTransferUser(index)">
                      <i></i>
                    </div>
                    <p v-cloak class="rt-crm-UserName">{{ user.fullname }}</p>
                  </div>
                  <div class="rt-crm-AddUser" @click="chooseAddUser()" v-show="transferInfo.userList.length == 0">
                    <div class="rt-crm-Avatar">+</div>
                    <p v-cloak class="rt-crm-UserName">
                      {{ $_t("新增", "common.add") }}
                    </p>
                  </div>
                  <div style="clear:both;"></div>
                </div>
              </div>
              <div class="rt-crm-ApproveSection">
                <h4 v-cloak class="rt-crm-ApproveSectionTitle">
                  {{ $_t("备注", "SER_Notes")
                  }}<span v-if="ApproveMemoRequired">({{ $_t("必填", "common.isrequired") }})</span>
                </h4>
                <textarea :placeholder="$_t('请填写备注', 'PLEASE_FILL_IN_THE_NOTES')" class="rt-crm-ApproveMemo"
                  v-model="transferInfo.memo"></textarea>
                <!-- <common-reviews class="commonleft"  :action-type="actionType" :commonreviews-selected="handleCommonReviewsSelected"></common-reviews> -->
                <!-- <CommonReviewsCollection class="commonright"  :action-type="actionType" :content="transferInfo.memo"></CommonReviewsCollection> -->
              </div>
            </div>

            <div class="rt-crm-submit" :class="{ marginTop54: [2, 3, 4].includes(actionType) }">
              <el-button @click="approve" :disabled="btnloading" :loading="btnloading">{{ $_t("提交", "BUTTON_SUBMIT")
                }}</el-button>
            </div>
          </div>
          <!-- 签核沟通 -->
          <div class="rt-crm-ApproveContent" v-if="iscommunicate == 1">
            <div class="rt-crm-ApproveTabContent">
              <div class="rt-crm-ApproveSection">
                <p style="color:#000;font-size:16px;">
                  {{ communicateBy.UserName }}
                </p>
                <p style="color:#555;font-size:14px;">
                  {{ communicateBy.Memo }}
                </p>
              </div>
              <div>
                <div class="rt-crm-ApproveSection">
                  <!-- 处理意见 -->
                  <div class="rt-crm-ApproveSectionTitle">
                    处理意见<span v-if="ApproveMemoRequired">({{ $_t("必填", "common.isrequired") }})</span>
                  </div>
                  <!-- 请填写处理意见 -->
                  <textarea class="rt-crm-ApproveMemo" v-model="communicate.memo" placeholder="请填写处理意见"></textarea>
                  <!-- <common-reviews class="commonleft" :action-type="actionType" :commonreviews-selected="handleCommonReviewsSelected"></common-reviews> -->
                  <!-- <CommonReviewsCollection class="commonright" :action-type="actionType" :content="communicate.memo"></CommonReviewsCollection> -->
                </div>
              </div>
            </div>
            <div class="rt-crm-submit marginTop54">
              <el-button @click="approve" :disabled="btnloading" :loading="btnloading">{{ $_t("提交", "BUTTON_SUBMIT")
                }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </rt-content>
    <rt-plat-lookup v-show="false" :entity="lookupList[radio].entity" :idField="lookupList[radio].idField"
      :disabled="false" ref="selectUser" v-model="selectUserId" :nameField="lookupList[radio].nameField"
      :dialog-display-fields="lookupList[radio].dialogDisplayFields"
      :dialog-order-fields="lookupList[radio].dialogOrderFields"
      :dialogFilterFields="lookupList[radio].dialogFilterFields" dialogConditionFields="isdisabled eq false" />
  </div>
</template>
<script>
import CommonReviewsCollection from "./CommonReviewsCollect";
export default {
  name:"Approve",
  props: {
    etn: {  
      type: String,
      required: false
    },
    decisiondisplay: { 
      type: String,
      required: false
    }},
  data() {
    return {
      decisiondisplayes:true,
      isProcessing: false,
      loading: false,
      pageCookie: "",
      isDynamicFlow: false,
      isneedCookie: false,
      isMyApproval: false,
      isAutoSave: false,
      btnloading: false,
      tabPosition: "top",
      approvestepId: null,
      lookupList: [
        {
          entity: "new_outeruser",
          idField: "new_outeruserid",
          nameField: "new_name",
          dialogDisplayFields: [
            { name: "new_name", label: "名称" },
            { name: "new_login", label: "用户名" }
          ],
          dialogOrderFields: [{ name: "new_name", descending: false }],
          dialogFilterFields: "new_outeruserid,new_name,new_login",
          dialogConditionFields: "isdisabled eq false"
        },
        {
          entity: "systemuser",
          idField: "systemuserid",
          nameField: "fullname",
          dialogDisplayFields: [
            { name: "fullname", label: "全名" },
            { name: "domainname", label: "用户名" }
          ],
          dialogOrderFields: [{ name: "fullname", descending: false }],
          dialogFilterFields: "fullname,domainname,systemuserid",
          dialogConditionFields: "isdisabled eq false"
        }
      ],
      actionType: 1,
      memo: "",
      addUsers: [],
      radio: 0,
      selectUserId: {},
      //历史记录
      entityName: null,
      entityId: null,
      stateList: [],
      trackList: [],
      approvedStepList: null,
      agreeInfo: {
        memo: ""
      },
      rejectInfo: {
        rejectToStepId: "",
        resubmitTypeId: 0,
        memo: ""
      },
      communicateInfo: {
        userList: [],
        memo: ""
      },
      transferInfo: {
        userList: [],
        memo: ""
      },
      communicate: {
        memo: ""
      },
      formCom: null,
      hackResetApprove: false,
      hackResetPage: true,
      approveShowBtn: false,
      allowCommunicate: false,
      enableRejectType:false,
      activeName: "page",
      communicateBy: {
        UserName: "",
        Memo: ""
      } //转沟通过来的人的信息
    };
  },
  components: {
    CommonReviewsCollection
  },
  mounted: function () {
    this.entityName = (this.etn != null) ? this.etn : this.$route.params.etn;
    this.entityId = this.$route.params.id;
    this.formCom = this.entityName + "View";
    if(this.decisiondisplay)
    {
      this.decisiondisplayes=false;
      this.activeName="approve";
    }

    this.reload();
   // this.isAllowCommunicate();
  },
  watch: {
    selectUserId(value) {
      this.selectUserId = value;
      this.handleDataSelected(this.selectUserId);
    }
  },
  computed: {
    ApproveMemoRequired() {
      if (this.$store.state && this.$store.state.systemparameter) {
        return this.$store.state.systemparameter.ApproveMemoRequired == "true";
      } else return false;
    }
  },
  methods: {
    //判断是否启用沟通
    isAllowCommunicate: function () {
      rt.get(
        "/api/CrmLookupView/new_systemparameter?&condition=new_name eq Flow.Configuration &select=new_value"
      )
        .then(res => {
          if (res && res.Entities && res.Entities.length > 0) {
            if (res.Entities[0].new_value) {
              let value = JSON.parse(res.Entities[0].new_value);
              if (value.AllowCommunicate == 1) {
                this.allowCommunicate = true;
              }
              if(value.EnableRejectType==1){
                this.enableRejectType=true;
              }
            }
          }
        })
        .catch(error => {
          rt.hideLoadingToast();
          rt.showErrorToast(error);
        });
    },
    goDetail() {
      this.$router.push({
        name: this.entityName + "Edit",
        params: {
          id: this.entityId
        }
      });
    },
    handleClick(val) {
      if (val.index === "0") {
        this.hackResetPage = true;
        this.hackResetApprove = false;
      } else {
        this.hackResetPage = false;
        this.hackResetApprove = true;
      }
    },
    reload() {
      this.entityName = this.etn||this.$route.params.etn;
      this.entityId = this.$route.params.id;
      this.approvestepId = this.$route.params.stepid;
      this.iscommunicate = this.$route.params.iscommunicate;
      this.url =
        window.origin + "#/" + this.entityName + "/edit/" + this.entityId;

       if (this.iscommunicate == 1) {
        this.actionType = 5;
        var requestApi =
          "/api/dynamic/new_flowapproval_steps?&$filter=new_flowapproval_stepsid eq " +
          this.approvestepId +
          " &$select=new_communicate_userid,new_communicate_memo";
        rt.get(requestApi)
          .then(res => {
            if (res && res.Entities && res.Entities.length > 0) {
              var communicateUser = res.Entities[0].new_communicate_userid;
              if (communicateUser && communicateUser.id) {
                this.communicateBy.UserName = communicateUser.name;
              }
              this.communicateBy.Memo = res.Entities[0].new_communicate_memo;
            }
          })
          .catch(error => {
            rt.hideLoadingToast();
            rt.showErrorToast(error);
          });
       }
      if (this.approvestepId) {
        //加载历史申请人
        this.retrieveApprovedStepList();
        //是否自动保存
        this.IsApprovalAutoSave();
        //是否我的流程
        this.retrieveIsMyApproval();
        //加载加签用户
        this.retrieveAddUserList();
        //获取是否是动态签核
        this.getIsDynamicFlow();
      }
    },    
    getIsDynamicFlow(){
      if(this.approvestepId){
        let that = this;
        rt.get("api/CrmFlow/IsDynamicFlow?approveStepId="+this.approvestepId)
          .then(res=>{
            if(res){
              that.isDynamicFlow = res=="true";
            }
          })
          .catch(error => {
            rt.showErrorToast(error);
          });
      }
    },
    IsApprovalAutoSave() {
      if (this.approvestepId) {
        let apiUrl =
          "api/CrmFlow/IsApprovalAutoSave" +
          "?ApproveStepId=" +
          this.approvestepId;
        let that = this;
        rt.get(apiUrl)
          .then(res => {
            that.isAutoSave = res;
          })
          .catch(error => {
            rt.showErrorToast(1 + error);
          });
      }
    },
    GetApprovedStepList() {
      let apiUrl =
        "api/CrmFlow/GetApprovedStepList" +
        "?entityName=" +
        this.entityName +
        "&entityId=" +
        this.entityId;
      let that = this;
      rt.get(apiUrl)
        .then(res => {
          this.btnloading = false;
          that.stateList = res;
        })
        .catch(error => {
          this.btnloading = false;
          rt.showErrorToast(2 + error);
        });
    },
    //获取操作
    retrieveApprovedStepList() {
      let apiUrl =
        "api/CrmFlow/GetApprovedStepList" +
        "?entityName=" +
        this.entityName +
        "&entityId=" +
        this.entityId;
      let that = this;
      rt.get(apiUrl)
        .then(res => {
          that.approvedStepList = res;
        })
        .catch(error => {
          that.btnloading = false;
          rt.showErrorToast(3 + error);
        });
    },
    //获取日志
    retrieveTrackList: function () {
      let apiUrl =
        "api/CrmFlow/GetFlowApproveLogList" +
        "?entityName=" +
        this.entityName +
        "&entityId=" +
        this.entityId;
      const that = this;
      rt.get(apiUrl)
        .then(res => {
          that.trackList = res;
        })
        .catch(error => {
          rt.showErrorToast(error);
        });
    },
    //验证是否可以操作
    retrieveIsMyApproval: function () {
      if (
        this.approvestepId == null ||
        this.approvestepId.length < 1 ||
        this.approvestepId == " "
      ) {
        this.isMyApproval = false;
        return;
      }
      let apiUrl =
        "api/CrmFlow/IsMyApprove" + "?ApproveStepId=" + this.approvestepId;
      rt.get(apiUrl)
        .then(res => {
          this.isMyApproval = res;
          if (this.isMyApproval) {
            this.GetApprovedStepList();
          } else {
            this.btnloading = false;
          }
        })
        .catch(error => {
          rt.showErrorToast(error);
        });
    },
    //加签用户
    retrieveAddUserList: function () {
      if (
        this.approvestepId == null ||
        this.approvestepId.length < 1 ||
        this.approvestepId == " "
      ) {
        return null;
      }
      let apiUrl =
        "api/CrmFlow/GetApproveStepAddUserList" +
        "?entityName=new_flowapproval_stepses" +
        "&approveStepId=" +
        this.approvestepId;
      rt.get(apiUrl)
        .then(res => {
          this.addUsers = res;
        })
        .catch(error => {
          rt.showErrorToast(error);
        });
    },
    approve: function () {
      let that = this;
      if (this.actionType == null) {
        this.actionType = 1;
      }
      if (
        this.approvestepId == null ||
        this.approvestepId.length < 1 ||
        this.approvestepId == " "
      ) {
        return null;
      }
      let apiUrl = "";
      // 通过或沟通处理
      console.log(this.actionType);
      if (this.actionType == 1 || this.actionType == 5) {
        //通过        
        if (this.ApproveMemoRequired && (this.agreeInfo.memo == null || this.agreeInfo.memo.length < 1)) {
          // 请填写签核意见
          rt.showErrorToast(
            this.$_t("approval.enterApprovalMemo", "请填写签核意见")
          );
          return;
        }
        apiUrl = "api/CrmFlow/FlowAgree";
        var params = {
          entityName: this.entityName,
          entityId: this.entityId,
          memo: ""
        };
        if (this.actionType == 1) {
          if (this.agreeInfo.memo != null && this.agreeInfo.memo.length > 0) {
            params.memo = this.agreeInfo.memo;
          }
        }
        else {
          if (this.communicate.memo != null && this.communicate.memo.length > 0) {
            params.memo = this.communicate.memo;
          }
        }
      }
      else if (this.actionType == 2) {
        if (this.ApproveMemoRequired && (this.rejectInfo.memo == null || this.rejectInfo.memo.length < 1)) {
          // 请填写签核意见
          rt.showErrorToast(
            this.$_t("approval.enterApprovalMemo", "请填写签核意见")
          );
          return;
        }
        var rejectMemo = that.rejectInfo.memo;
        var rejectToStepId = that.rejectInfo.rejectToStepId;
        var rejectType = rt.isNullOrWhiteSpace(rejectToStepId) ? 0 : 1;
        var resubmitType = that.rejectInfo.resubmitTypeId;
        apiUrl = "api/CrmFlow/FlowReject";
        params = {
          rejectType: rejectType,
          rejectToStepId: rejectToStepId,
          entityName: this.entityName,
          entityId: this.entityId,
          memo: rejectMemo,
          options: "{ResubmitTypeId:" + resubmitType + "}"
        };
      }
      else if (this.actionType == 3) {
        //沟通
        if (this.communicateInfo.userList == null || this.communicateInfo.userList.length < 1) {
          // 请添加沟通用户
          rt.showErrorToast(
            this.$_t("approval.addcommunicateusers", "请添加沟通用户")
          );
          return;
        }

        if (this.ApproveMemoRequired && (this.communicateInfo.memo == null || this.communicateInfo.memo.length < 1)) {
          rt.showErrorToast(this.$_t("PLEASE_FILL_IN_THE_NOTES", "请填写备注"));
          return;
        }
        apiUrl = "api/CrmFlow/FlowCommunicate";
        params = {
          entityName: this.entityName,
          entityId: this.entityId,
          userList: this.communicateInfo.userList,
          memo: this.communicateInfo.memo
        };
      }
      else if (this.actionType == 4) {
        //转办
        if (this.transferInfo.userList == null || this.transferInfo.userList.length < 1) {
          // 请添加转办用户
          rt.showErrorToast(
            this.$_t("approval.addtransferusers", "请添加转办用户")
          );
          return;
        }
        if (this.ApproveMemoRequired && (this.transferInfo.memo == null || this.transferInfo.memo.length < 1)) {
          rt.showErrorToast(this.$_t("PLEASE_FILL_IN_THE_NOTES", "请填写备注"));
          return;
        }
        apiUrl = "api/CrmFlow/FlowTransfer";
        params = {
          entityName: this.entityName,
          entityId: this.entityId,
          userList: this.transferInfo.userList,
          memo: this.transferInfo.memo
        };
      } else {
        // 未知的actionType
        rt.showErrorToast(
          this.$_t("approval.undefindactiontype", "未知的actionType")
        );
      }
      this.isProcessing = true;
      this.btnloading = true;
      rt.showLoadingToast(this.$_t("SUBMITTING", "正在提交..."));
      rt.post(apiUrl, params)
        .then(res => {
          rt.hideLoadingToast();
          rt.showSuccessToast(res);
          // that.$refs._RTFlowApprovalList.dataBind();
          //是否我的流程
          that.retrieveIsMyApproval();
          that.isMyApproval = false;
          this.$router.go(-1);
          //路由 跳转至 列表页
          //   this.$router.push({
          //     name: "ApproveList"
          //   })
        })
        .catch(error => {
          this.btnloading = false;
          rt.hideLoadingToast();
          rt.showErrorToast(error);
          that.isProcessing = false;
        });
    },
    chooseAddUser: function () {
      this.$refs.selectUser.showLookupDialog();
    },
    handleDataSelected: function (obj) {
      if (obj == null || obj.id == null || obj.id.length < 1) {
        return;
      }
      if (this.iscommunicate == 0) {
        if (this.actionType == 1) {
          try {
            let apiUrl =
              "api/CrmFlow/FlowCountersign" +
              "?approveStepId=" +
              this.approvestepId +
              "&userId=" +
              obj.id + '&logicalName=' + this.lookupList[this.radio].entity;
            let that = this;
            rt.get(apiUrl)
              .then(res => {
                this.retrieveAddUserList();
              })
              .catch(error => {
                rt.showErrorToast(error);
              });
          } catch (e) {
            rt.alertDialog(e.message);
          }
        } else if (this.actionType == 3) {
          this.communicateInfo.userList.push({
            systemuserid: obj.id,
            fullname: obj.name,
            logicalName: this.lookupList[this.radio].entity
          });
        } else if (this.actionType == 4) {
          this.transferInfo.userList.push({
            systemuserid: obj.id,
            fullname: obj.name,
            logicalName: this.lookupList[this.radio].entity
          });
        }
      }
    },
    deleteAddUser: function (user) {
      this.$confirm(
        this.$_t(
          "此操作将永久删除记录，是否继续？",
          "ThisActionDeletePerpetually"
        ),
        this.$_t("提示", "Tip"),
        {
          confirmButtonText: this.$_t("确定", "BUTTON_DETERMINE"),
          confirmButtonClass: "ConfirmButtonClass",
          cancelButtonText: this.$_t("取消", "BUTTON_CANCEL"),
          cancelButtonClass: "CancelButtonClass",
          type: "warning"
        }
      ).then(() => {
        try {
          let apiUrl =
            "api/CrmFlow/CancelFlowCounterSign" +
            "?approveStepId=" +
            this.approvestepId +
            "&userId=" +
            user.systemuserid + '&logicalName=' + this.lookupList[this.radio].entity;
          rt.get(apiUrl)
            .then(res => {
              this.retrieveAddUserList();
            })
            .catch(error => {
              rt.showErrorToast(error);
            });
        } catch (e) {
          rt.alertDialog(e.message);
        }
      });
    },
    deleteCommunicateUser: function (index) {
      this.communicateInfo.userList.splice(index, 1);
    },
    deleteTransferUser: function (index) {
      this.transferInfo.userList.splice(index, 1);
    },
    handleCommonReviewsSelected: function (obj) {
      if (!obj || !obj.content) {
        return;
      }
      var actionType = obj.actionType;
      if (actionType == 1) {
        //同意
        this.agreeInfo.memo = obj.content;
      } else if (actionType == 2) {
        //驳回
        this.rejectInfo.memo = obj.content;
      } else if (actionType == 3) {
        //沟通
        this.communicateInfo.memo = obj.content;
      } else if (actionType == 4) {
        //转办
        this.transferInfo.memo = obj.content;
      } else if (actionType == 5) {
        //审批类型=沟通
        this.communicate.memo = obj.content;
      } else {
        throw new Error("未知的actionType");
      }
    }
  }
};
</script>

<style scoped lang="less">
.approveList {
  padding: 0 16px;
}

.userSelect {
  margin-bottom: 6px;
  padding-right: 8px;
  box-sizing: border-box;
}

.Approve {
  #approvemain {
    .appcontent {
      margin-top: -40px;
      display: flex;
      justify-content: flex-start;
    }

    #left {
      width: calc(100% - 300px);
    }

    .leftAll {
      width: 100% !important;
    }

    .el-autocomplete .el-input {
      display: none;
    }

    #right {
      width: 300px;
      background-color: #eeeeee;
    }

    .rt-crm-Grid {
      min-height: 200px;
      position: relative;
      flex: 1;
    }

    .rt-crm-ApproveHeader {
      margin: 10px;
    }

    .rt-crm-ApproveTabContent {
      padding: 0 13px;
    }

    .rt-crm-ApproveSection {
      color: #2a72c5;
      font-size: 12px;
      margin-top: 28px;
    }

    .rt-crm-ApproveSectionTitle {
      margin-bottom: 10px;
      font-weight: bold;
    }

    .rt-crm-ApproveContent {
      flex: 1;
      background-color: #fff;
      margin: 0 10px 0;
      overflow: auto;
      min-height: 450px;

      select,
      textarea {
        width: 100%;
      }

      select {
        border-radius: 5px;
        height: 26px;
        border: 1px solid #cccccc;
        color: #222222;
        padding-left: 6px;
      }
    }

    .rt-crm-ApproveMemo {
      height: 96px;
      padding: 3px;
      font-size: 13px;
      border: 1px solid #d3d3d3;
      color: #222222;
    }

    .rt-crm-Avatar {
      width: 38px;
      height: 38px;
      line-height: 38px;
      border: 1px solid rgb(204, 204, 204);
      border-radius: 50%;
      font-size: 26px;
      color: #888888;
      font-weight: 100;
      text-align: center;
      margin-bottom: 10px;
    }

    .rt-crm-AddedUser,
    .rt-crm-AddUser {
      display: inline-block;
      text-align: center;
      margin-right: 20px;
      margin-bottom: 10px;
      cursor: pointer;
      position: relative;
    }

    .rt-crm-AddedUser .rt-crm-Avatar {
      width: 38px;
      height: 38px;
      line-height: 38px;
      border-radius: 50%;
      font-size: 18px;
      color: #ffffff;
      background-color: #f7a072;
      margin: 0 auto;

      &:hover+.rt-crm-DeleteMask {
        display: block;
      }
    }

    .rt-crm-AddedUser .rt-crm-DeleteMask {
      display: none;
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.5);
      text-align: center;
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;

      &:hover {
        color: #fff;
        display: block;
      }

      i {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABN0lEQVQ4T43TuUpDQRSA4f93KewUF9BKEIKtYJFOS/EJFAIupWDQznRamU4hYOlSiL6BrZYptBYClgqKW2WhZuSCV65DLslUwzlnvlmYIy1GCOESmIlSV+psXG4cCCH0AB/AJPD8mx8EboE+9Su75g8IIdSANaCr1akysSZwoK4nsSzw3cHi1Gmq3THQ32bnf2n1LQZ2ga0OkapaiYEzYKFD4FxdjIE9YAOYAF6AV2AceM/Mkwe+A/bVzRhIjp9co6A2QggBGEjums6BIaABVNRqDKwAh0BRrecABaAOrKpHMTAHXADz6kUOUMzWxMAUcAOU1NMcYB44BabV6xgYBe6BslrLAUpA8mPH1IcYSHrgE9hRt3OAcpIHetOe+NdMIYRHYLjNX3hSR9KaGDgGltoAJ+pyWvMDDrCZER8NpS8AAAAASUVORK5CYII=");
        background-repeat: no-repeat;
        background-size: cover;
        margin-top: 10px;
      }
    }

    .rt-crm-AddedUser .rt-crm-UserName {
      color: #222222;
      font-size: 12px;
      margin-top: 8px;
    }

    .rt-crm-ApproveTabList {
      background-color: #f5f7fa;
      display: flex;
    }

    .rt-crm-ApproveTab.selected {
      color: #555555;
      background-color: #ffffff;
      border-bottom-color: #ffffff;
    }

    .rt-crm-ApproveTab {
      flex: 1;
      text-align: center;
      display: inline-block;
      height: 30px;
      line-height: 30px;
      color: #888888;
      font-size: 12px;
      position: relative;
      border-bottom: 1px solid #e3e3e3;
      cursor: pointer;
    }

    .rt-crm-submit {
      margin-top: 30px;
      padding-bottom: 30px;
      text-align: center;
    }

    .marginTop54 {
      margin-top: 54px;
    }

    .rt-crm-CommonReviewsBtn {
      margin-top: 8px;
      display: flex;
      align-items: center;
      color: #555555;

      &:hover {
        cursor: pointer;
      }
    }

    .rt-crm-CommonReviewsIconLookup {
      background-image: url("data:image/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjY5QUFDRDU0RkZFMzExRTZCQUVEQ0NBODk1MkQxNEQ1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjY5QUFDRDU1RkZFMzExRTZCQUVEQ0NBODk1MkQxNEQ1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjlBQUNENTJGRkUzMTFFNkJBRURDQ0E4OTUyRDE0RDUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NjlBQUNENTNGRkUzMTFFNkJBRURDQ0E4OTUyRDE0RDUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7pyG2XAAABXElEQVR42qSTPUsDQRCGXXOSEBHtAhI7iaAogogpxM5OrGwUDCgIp3/g7LT0EKxsLWKhWNj4gYVgxCKFpEiVNBEEsRAtrJT4wfkszMG65iCShYf37mbnnb3dWRUEQVsrwzFffN9PIKuQg0GIwR0cwY7nea+2gQpXQHIaOYcRqMAN1GECsvAIM5iU/xiQHOf5FjLgwj4TA2Nl08ghfMIosacw1i7qSmWXYN5M1oP3S2QWUrBhxkKDRajqylGbhUkROYF5VuTYBsNQsCs3GFfQA2nbQO/2exOnVheN2wb3MN6EwZhs5INtcAxT/Fs2KpNYH7IAF/zqm22wDS/aiIlDDZJ7kVPohM2oRppEziAJebiGL2miJeiWnAPdqazi+5eBmPQjW3LmHfJZTyjAOixLz+zBij41xzrrGjKHURc6ICY1vj9LgZLReB+wpv57GzFRyK4uhHFKtXqdfwQYAIEDegEF+RJcAAAAAElFTkSuQmCC");
      background-repeat: no-repeat;
      background-size: cover;
    }

    .rt-crm-Icon {
      width: 12px;
      height: 12px;
      vertical-align: text-bottom;

      &:hover {
        cursor: pointer;
      }
    }
  }

 #approvemain div#contentMain {
    padding: 0;
  }

  .commonleft {
    float: left;
  }

  .commonright {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// Approve.vue?4575db6f